/**
 * Copyright (c) 2026, CheckPlus Limited
 */
import { checkURL } from "./common.js";

export const validProjrctInfo = {
  validUrl: (url) => {
    return checkURL(url);
  },
};
